import { type FC } from "react";

import { cn } from "@/components/podkit/lib/cn";
import { Pill, type PillVariant } from "@/components/podkit/status/Pill";
import { OrganizationTier } from "gitpod-next-api/gitpod/v1/organization_pb";

export type TierBadgeProps = {
    tier: OrganizationTier;
    className?: string;
};

type TierConfig = {
    displayName: string;
    variant: PillVariant;
    className?: string;
};

function getTierConfig(tier: OrganizationTier): TierConfig | null {
    switch (tier) {
        case OrganizationTier.FREE:
        case OrganizationTier.FREE_ONA:
            return { displayName: "Free", variant: "neutral" };
        case OrganizationTier.CORE:
            // Maroon/brown color for Core tier
            return {
                displayName: "Core",
                variant: "neutral",
                className:
                    "bg-[rgb(var(--ona-brown-600)/0.15)] text-[rgb(var(--ona-brown-600))] dark:bg-[rgb(var(--ona-brown-100)/0.2)] dark:text-[rgb(var(--ona-brown-100))]",
            };
        case OrganizationTier.ENTERPRISE:
            return { displayName: "Enterprise", variant: "brand" };
        default:
            return null;
    }
}

/**
 * Badge component for displaying organization tier
 */
export const TierBadge: FC<TierBadgeProps> = ({ tier, className }) => {
    const config = getTierConfig(tier);

    if (!config) {
        return null;
    }

    return (
        <Pill variant={config.variant} size="sm" className={cn(config.className, className)}>
            {config.displayName}
        </Pill>
    );
};
